(function () {
	'use strict';

	function hydrateVideo(video) {
	if (!video) return;

	// force copy all <source data-src> to src
	video.querySelectorAll('source[data-src]').forEach(source => {
	  const newSrc = source.dataset.src;
	  if (newSrc && source.getAttribute('src') !== newSrc) {
		source.setAttribute('src', newSrc);
	  }
	});

	// reload the video after swapping sources
	try { video.load(); } catch (e) {}

	// autoplay if flagged
	if (
	  video.hasAttribute('autoplay') ||
	  video.hasAttribute('data-video-autoplay') ||
	  video.dataset.videoAutoplay === 'true'
	) {
	  video.muted = true;
	  video.playsInline = true;
	  const p = video.play();
	  if (p && typeof p.catch === 'function') p.catch(() => {});
	}

	// mark as hydrated for later, but don’t skip if already had data-hydrated
	video.dataset.hydrated = '1';
	}

	function primeExisting() {
	document.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
	}

	// mutation observer to hydrate new videos added later
	const observer = new MutationObserver(mutations => {
	mutations.forEach(m => {
	  if (m.addedNodes && m.addedNodes.length) {
		m.addedNodes.forEach(node => {
		  if (!(node instanceof HTMLElement)) return;
		  if (node.matches && node.matches('video[data-video-type="native"]')) {
			hydrateVideo(node);
		  } else if (node.querySelectorAll) {
			node.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
		  }
		});
	  }
	});
	});

	function startAll() {
	primeExisting();
	observer.observe(document.documentElement, {
	  childList: true,
	  subtree: true
	});
	}

	// trigger once on first mouse move or touch
	window.addEventListener('mousemove', startAll, { once: true, passive: true });
	window.addEventListener('touchstart', startAll, { once: true, passive: true });
	})();

	// this code for Some ELements  are first hide and show after user intraction..(start)
		// document.addEventListener("DOMContentLoaded", () => {
		// 	document.body.classList.add("itg_before_hide");
		// 	['mousemove', 'click', 'touchstart', 'pointerdown','scroll'].forEach(eventType => {
		// 		window.addEventListener(eventType, () => {
		// 			document.body.classList.remove("itg_before_hide");
		// 		}, { once: true });
		// 	});
		// });

		document.addEventListener("DOMContentLoaded", () => {
			document.body.classList.add("itg_before_hide");
			const events = ['mousemove','click','touchstart','pointerdown','scroll', 'touchmove','wheel'];
			const removeClass = e => {
				document.body.classList.remove("itg_before_hide");
				events.forEach(ev => {
				window.removeEventListener(ev, removeClass, {passive:true,capture:true});
				document.removeEventListener(ev, removeClass, {passive:true,capture:true});
				});
			};
			events.forEach(ev => {
				window.addEventListener(ev, removeClass, {passive:true,capture:true});
				document.addEventListener(ev, removeClass, {passive:true,capture:true});
			});
		});


		// document.addEventListener("DOMContentLoaded", () => {
		// 	document.body.classList.add("itg_before_hide");
		// 	const events = ['touchstart','touchmove','click','pointerdown','scroll','wheel','keydown'];
		// 	const fn = () => {
		// 		document.body.classList.remove("itg_before_hide");
		// 		events.forEach(ev => {
		// 		window.removeEventListener(ev, fn, {passive:true,capture:true});
		// 		document.removeEventListener(ev, fn, {passive:true,capture:true});
		// 		});
		// 	};
		// 	events.forEach(ev => {
		// 		window.addEventListener(ev, fn, {passive:true,capture:true});
		// 		document.addEventListener(ev, fn, {passive:true,capture:true});
		// 	});
		// });

	// this code for Some ELements  are first hide and show after user intraction..(End)